import SplitChart from './SplitChart'

export default SplitChart
